import { mergeClasses } from '@fluentui/react-components';
import { useEffect, useState } from 'react';
import { matchPath, Outlet, useLocation } from 'react-router';
import { app } from '@microsoft/teams-js';

import { Grid } from '@tdp/common/fluentV9MigrationComponents';
import { Header } from '@tdp/common/header';
import { HostType } from '@tdp/common/host';
import { LeftNav } from '@tdp/common/leftNav';
import Notifications from '@tdp/common/notification/Notification';
import { settingsSlice } from '@tdp/common/settings';
import { ScreenSizes, useScreenSize } from '@tdp/common/shared';
import { useSelector } from '@tdp/core';

import { useStyles } from './DeveloperPortalLayout.Styles';

export const DeveloperPortalLayout = () => {
  const largeScreen = useScreenSize(ScreenSizes.Large);
  const smallScreen = useScreenSize(ScreenSizes.Small);
  const [isExpanded, setIsExpanded] = useState(largeScreen);
  const classes = useStyles();
  const appRunContext = useSelector(settingsSlice.selectors.appRunContext);

  // expand leftNav if screen size is large
  useEffect(() => {
    setIsExpanded(largeScreen);
  }, [largeScreen]);

  const path = useLocation().pathname;

  useEffect(() => {
    const match = matchPath({ path: '/apps/:appId/', end: false }, path);
    if (match && isExpanded) {
      setIsExpanded(false);
    }
  }, [path]);

  // if screen size is small then expand the nav-menu Items
  useEffect(() => {
    // when screen size changes to small then
    // header, sidebar and main aligns on one straight line vertically. Expanding the nav-menu Items
    if (smallScreen) {
      setIsExpanded(true);
    }
  }, [smallScreen]);

  if (appRunContext?.host === HostType.TEAMS) {
    app.notifySuccess();
    return (
      <main className={classes.main} id="teams-layout">
        <div className={classes.mainScroll}>
          <Notifications />
          <Outlet />
        </div>
      </main>
    );
  }

  return (
    <Grid
      id="layoutGrid"
      className={mergeClasses(
        classes.layoutGrid,
        !isExpanded && classes.sideBarCollapsed
      )}
      data-testid="developer-portal-grid-layout"
    >
      <header className={classes.header}>{<Header />}</header>
      <div className={classes.sidebar}>
        <LeftNav setIsExpanded={setIsExpanded} isExpanded={isExpanded} />
      </div>
      <main className={classes.main}>
        <div className={classes.mainScroll}>
          <Notifications />
          <Outlet />
        </div>
      </main>
    </Grid>
  );
};
